import { NgModule } from '@angular/core';
import { RouterModule, Routes, UrlMatchResult, UrlSegment } from '@angular/router';
import { UnauthorizedComponent } from './shared/shared/unauthorized/unauthorized.component';

export function msalHashCallbackMatcher(segments: UrlSegment[]): UrlMatchResult | null {
  if (!segments.length) {
    return null;
  }

  const raw = segments.map(s => s.path).join('/');
  const decoded = decodeURIComponent(raw);
  const isMsalCallback =
    decoded.startsWith('code=') ||
    decoded.startsWith('error=') ||
    decoded.includes('&client_info=') ||
    decoded.includes('&session_state=');

  return isMsalCallback ? { consumed: segments } : null;
}

const routes: Routes = [
  {
    matcher: msalHashCallbackMatcher,
    redirectTo: 'home'
  },
  {
    path: 'unauthorized',
    component: UnauthorizedComponent
  },
  {
    path: 'cheque-submission',
    loadChildren: () =>
      import('./modules/utilities/cheque-submission/cheque-submission.module').then(m => m.ChequeSubmissionModule)
  },
  {
    path: '',
    loadChildren: () =>
      import('./modules/supervision/supervision.module').then(m => m.SupervisionModule)
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
